<!-- *************************************************************************
TEMPLATE
************************************************************************* -->
<template>
  <div class="compos">
    <div
      v-if="actualViewName === 'name'"
      id="name_page"
      class="container"
    >
      <div class="box dialog">
        <center style="position: relative;">
          <h2 id="title_name_page">
            {{ $t("quiz.intro") }}<span class="highlight_span">
              {{ $t("quiz.intro2") }}
            </span>
            <span class="bold_span">
              {{ quizData.name }}
            </span>
          </h2>
        </center>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 13.41 20.91"
        >
          <title>dialog_fin</title><path
            d="M13.41,16.86S4.83,22.08,0,20.67C5.58,16.33,4.67,0,4.67,0h0"
            style="fill:#ddd"
          />
        </svg>
      </div>
      <!-- <div id="ad_quiz_1" /> -->
      <div class="box namepage">
        <div style="padding: 10px 30px 30px;">
          <div class="input_name">
            <h4
              id="enter_name_text"
              class="input_title"
            >
              {{ $t('index.name') }}
            </h4>
            <b-input
              v-model="friendName"
              maxlength="15"
              placeholder="Alex..."
              required
              @keyup.enter.native="save_name"
            />

            <div
              id="info_namepage"
              class="infobox"
            >
              <i class="fas fa-ellipsis-h" />
              <span id="note_on_name_page">
                Note:
              </span>
            </div>
          </div>

          <button
            id="name_button"
            class="fullWidthButton button_2 pushdown"
            type="button"
            @click="save_name"
          >
            {{ $t('index.started') }}
          </button>
        </div>
      </div>

      <!-- 300x250 waldo-tag-15169 -->
      <div id="ad-below-name" style="margin-bottom: 10px; text-align: center;" />
    </div>

    <!-- 728x90 sticky footer Desktop Only
    <div id="waldo-tag-15164" /> -->

    <!-- <div
      v-if="actualViewName === 'name'"
      id="ad_quiz_2"
    /> -->
    <!-- <Ad4Compo
      v-if="actualViewName === 'name'"
    /> -->
    <ChartCompo
      v-if="actualViewName === 'name'"
      :quiz-data="quizData"
    />
    <!-- <div
      v-if="actualViewName === 'name'"
      id="ad_quiz_3"
    /> -->
    <InstaembedCompo
      v-if="actualViewName === 'name'"
    />
    <!-- <InstaCompo
      v-if="actualViewName === 'name'"
    /> -->
    <ActionCompo
      v-if="actualViewName === 'action'"
      :quiz-data="quizData"
      :friend-name="friendName"
      :q-id="qId"
      :user-id="userId"
      :new-user="newUser"
    />
  </div>
</template>

<!-- *************************************************************************
SCRIPT
************************************************************************* -->

<script>
import { colorOptions, colorMatchs } from '@/consts'
import ActionCompo from '@/components/ActionCompo.vue'
import ChartCompo from '@/components/ChartCompo.vue'
// import InstaCompo from '@/components/InstaCompo.vue'
import InstaembedCompo from '@/components/InstaembedCompo.vue'
// import Ad4Compo from '@/components/Ad4Compo.vue'
import Vue from 'vue'
import RaptiveAds from '@/plugins/raptive.js';

export default {
  name: 'RegisterCompo',
  components: {
    ActionCompo,
    ChartCompo,
    // InstaCompo,
    InstaembedCompo
    // Ad4Compo
  },
  // eslint-disable-next-line
  props: [ 'quizData', 'qId', 'userId', 'newUser' ],
  data () {
    return {
      colorOptions: colorOptions,
      colorMatchs: colorMatchs,
      actualViewName: 'name',
      friendName: ''
      // playwireUnits: [
      //   // {
      //   //   selectorId: 'ad_quiz_1',
      //   //   type: 'leaderboard_atf'
      //   // },
      //   // {
      //   //   selectorId: 'ad_quiz_2',
      //   //   type: 'leaderboard_atf'
      //   // },
      //   {
      //     selectorId: 'ad_quiz_3',
      //     type: 'med_rect_btf'
      //   },
      //   {
      //     type: 'left_rail'
      //   },
      //   {
      //     type: 'right_rail'
      //   }
      // ]
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    Vue.use(RaptiveAds)
    // waldo.refreshTag('waldo-tag-15169')
  // As an instance method inside a component
    // this.$loadScript('//cdn.thisiswaldo.com/static/js/15148.js')
    //   .then(() => {
    //     // Script is loaded, do something
    //   })
    //   .catch(() => {
    //     // Failed to fetch script
    //   })
    // this.initTyche()
  },
  methods: {
    // initTyche () {
    //   // console.log('Tyche API is initialized')
    //   ramp.addUnits(this.playwireUnits)
    //     .then(() => {
    //       ramp.displayUnits()
    //     // callback function
    //     }).catch((e) => {
    //       // catch errors
    //       console.log(e)
    //     })
    // },
    save_name () {
      if (this.friendName.length >= 3) {
        // eslint-disable-next-line
        this.friendName = this.friendName.replace(/[&\\\#,+$~%.:;*<>{}|]/g, '')
        this.actualViewName = 'action'
        document.body.style.backgroundColor = colorOptions[this.quizData.questions[0].color]
        // console.log(colorOptions[this.quizData.questions[0].color + 1])
      } else if (!this.friendName.length) {
        this.danger(this.$t('index.lackname'))
      } else {
        this.danger(this.$t('index.tooshort'))
      }
    },
    danger (message) {
      this.$buefy.notification.open({
        closable: true,
        duration: 5000,
        message: message,
        position: 'is-top',
        type: 'is-danger',
        hasIcon: false
      })
    }

  }
}
</script>

<!-- *************************************************************************
STYLE
************************************************************************* -->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#ad_quiz_1, #ad_quiz_2, #ad_quiz_3 {
  margin-right: auto;
  margin-left: auto;
}
#ad_quiz_1{
  margin-top: -5px;
  margin-bottom: 10px;
}
#ad_quiz_2{
  margin-top: -30px;
  margin-bottom: 10px;
}
#ad_quiz_3{
  margin-top: 15px;
  margin-bottom: -10px
}
</style>
